/**
 * @generated SignedSource<<db17c135497da0c149c60e4d6d4c082a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuoteBlock_contentBlock$data = {
  readonly author: string | null | undefined;
  readonly iconUrl: string | null | undefined;
  readonly text: string;
  readonly " $fragmentType": "QuoteBlock_contentBlock";
};
export type QuoteBlock_contentBlock$key = {
  readonly " $data"?: QuoteBlock_contentBlock$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuoteBlock_contentBlock">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuoteBlock_contentBlock",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "author",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconUrl",
      "storageKey": null
    }
  ],
  "type": "QuoteBlock",
  "abstractKey": null
};

(node as any).hash = "edad5b69dad7beb4770f0efa1befeeeb";

export default node;
